Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DTriangleFace = module.exports.default = {
	BACK: "back",
	FRONT: "front",
	FRONT_AND_BACK: "frontAndBack",
	NONE: "none"
};